interface CustomerAvatarProps {
  name: string | null | undefined;
  /** Used for a stable color when there is no name. */
  seed: string | null | undefined;
}

function hashHue(text: string) {
  let hash = 0;
  for (const char of text) hash = (hash * 31 + char.charCodeAt(0)) % 360;
  return hash;
}

function getInitials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}

/** Initials on a color derived from the name, so the same customer looks the same everywhere. */
export function CustomerAvatar({ name, seed }: CustomerAvatarProps) {
  const label = name?.trim() || seed?.trim() || '';
  const hue = hashHue(label);
  return (
    <span
      aria-hidden="true"
      className="inline-flex size-8 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold"
      style={{
        backgroundColor: `hsl(${hue} 70% 50% / 0.15)`,
        color: `hsl(${hue} 60% 40%)`,
      }}
    >
      {label ? getInitials(label) : '?'}
    </span>
  );
}
